<template lang="pug">
  .barra-busca
    form(:action="baseUrl + 'busca'")
      .form-group
        .icon: i.fa.fa-search.fa-lg
        input.form-control(type="text" name="s")
</template>

<style lang="scss">
  // Vars

  // Style
  .barra-busca {
    float: right;
    padding: 40px 0;
    display: inline-block;
    .form-group {
      position: relative;
      .icon {
        position: absolute;
        right: 7px;
        top: 5px;
        z-index: 1;
        color: $color-green-dark;
      }
    }
    .form-control {
      position: relative;
      background-color: #E0E0E0;
      border-radius: 7px;
      min-width: 180px;
    }
  }
</style>

<script>
import * as urls from '../../js/config'

export default {
  name: 'barra-busca',
  data () {
    return {
      baseUrl: urls.URL_BASE
    }
  },
  methods: {
    savePost: function () {
      this.$http.post('/busca', this.post)
      .success(function (post) {
        this.$route.router.go('/')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BarraBusca.vue?3b487086